/**
 * Loader Component
 * Full-page or inline loading indicator
 */

import React from 'react';

import './loader.scss';

export interface LoaderProps {
    fullPage?: boolean;
    pulse?: boolean;
    size?: 'small' | 'medium' | 'large';
    message?: string;
}

export const Loader: React.FC<LoaderProps> = React.memo(
    ({ fullPage = false, pulse = true, size = 'small', message }) => {
        const classNames = ['loader', fullPage && 'loader--full-page', `loader--${size}`].filter(Boolean).join(' ');

        return (
            <div className={classNames} role="status" aria-live="polite">
                <img
                    src="https://assets.prizeout.com/branding/po-logo-circle.svg"
                    alt="Loading"
                    className={`loader__logo ${pulse ? 'loader__logo--pulse' : ''}`}
                />
                {message && <p className="loader__message">{message}</p>}
            </div>
        );
    },
);

Loader.displayName = 'Loader';

export default Loader;
